const views = [
  'listings',
  'items',
]

export { views }
